import React, { useEffect, useRef } from "react";
import { CSSProperties } from "styled-components";

interface IntroCinematicProps {
  onPlaying: (video: HTMLVideoElement) => void;
  onEnded?: () => void;
  style: CSSProperties;
}

const IntroCinematic: React.FC<IntroCinematicProps> = ({
  onPlaying,
  onEnded,
  style,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const EmbudoResult: string = 'https://lotteryblob.blob.core.windows.net/lottery-files/embudo-result.webm';

  useEffect(() => {
    const videoElement = videoRef.current;

    if (videoElement) {
      onPlaying(videoElement);

      const handleEnded = () => {
        if (onEnded) {
          onEnded();
        }
      };

      videoElement.addEventListener("ended", handleEnded);

      return () => {
        videoElement.removeEventListener("ended", handleEnded);
      };
    }
  }, [onPlaying, onEnded]);

  return (
    <video
      ref={videoRef}
      className="intro m-0 p-0"
      src={EmbudoResult}
      autoPlay
      muted
      style={{ height: "auto", width: "100%", ...style }}
    >
      <source src={EmbudoResult} type="video/webm"></source>
    </video>
  );
};

export default IntroCinematic;
